"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = Component;

var _react = _interopRequireWildcard(require("react"));

var _Input = _interopRequireDefault(require("../components/inputs/Input"));

var _ItemList = _interopRequireDefault(require("../components/inputs/ItemList"));

var _Wizard = _interopRequireDefault(require("../components/wizards/Wizard"));

var _WizardStep = _interopRequireDefault(require("../components/wizards/WizardStep"));

var _RadioButtonsGroup = _interopRequireDefault(require("../components/selectors/RadioButtonsGroup"));

var _Checkbox = _interopRequireDefault(require("../components/inputs/Checkbox"));

var _ConfirmationBox = _interopRequireDefault(require("../components/inputs/ConfirmationBox"));

var _Date = _interopRequireDefault(require("../components/inputs/Date"));

var _LinearWizard = _interopRequireDefault(require("../components/wizards/LinearWizard"));

var _PlainWizard = _interopRequireDefault(require("../components/wizards/PlainWizard"));

var _WizardSelectStep = _interopRequireDefault(require("../components/wizards/WizardSelectStep"));

var _WizardConfirmStep = _interopRequireDefault(require("../components/wizards/WizardConfirmStep"));

var _DotsWizard = _interopRequireDefault(require("../components/wizards/DotsWizard"));

var _Form = _interopRequireDefault(require("../components/forms/Form"));

var _Card = _interopRequireDefault(require("../components/layout/Card"));

var _Html = _interopRequireDefault(require("../components/layout/Html"));

var _RadioButtons = _interopRequireDefault(require("../components/inputs/RadioButtons"));

var _CheckBoxes = _interopRequireDefault(require("../components/inputs/CheckBoxes"));

var _GenericStore = require("../components/store/GenericStore");

var _FormImage = _interopRequireDefault(require("../components/inputs/FormImage"));

var ComponentList = {
  INPUT: _Input["default"],
  WIZARD: _Wizard["default"],
  LINEAR_WIZARD: _LinearWizard["default"],
  DOTS_WIZARD: _DotsWizard["default"],
  PLAIN_WIZARD: _PlainWizard["default"],
  WIZARD_STEP: _WizardStep["default"],
  WIZARD_SELECT_STEP: _WizardSelectStep["default"],
  WIZARD_CONFIRM_STEP: _WizardConfirmStep["default"],
  RADIO_BUTTONS_GROUP: _RadioButtonsGroup["default"],
  CHECKBOX: _Checkbox["default"],
  CONFIRMATION_BOX: _ConfirmationBox["default"],
  ITEM_LIST: _ItemList["default"],
  FORM: _Form["default"],
  CARD: _Card["default"],
  HTML: _Html["default"],
  RADIOBUTTONS: _RadioButtons["default"],
  CHECKBOXES: _CheckBoxes["default"],
  IMAGE: _FormImage["default"],
  DATE: _Date["default"]
};

function Component(props) {
  // component does exist
  var block = props.block,
      _props$parentPath = props.parentPath,
      parentPath = _props$parentPath === void 0 ? '' : _props$parentPath,
      _props$number = props.number,
      number = _props$number === void 0 ? 0 : _props$number,
      _props$onSubmit = props.onSubmit,
      onSubmit = _props$onSubmit === void 0 ? function () {
    return null;
  } : _props$onSubmit,
      _props$isAutoSave = props.isAutoSave,
      isAutoSave = _props$isAutoSave === void 0 ? false : _props$isAutoSave,
      _props$isLogInArray = props.isLogInArray,
      isLogInArray = _props$isLogInArray === void 0 ? false : _props$isLogInArray,
      _props$isPrecondition = props.isPreconditionData,
      isPreconditionData = _props$isPrecondition === void 0 ? false : _props$isPrecondition;
  (0, _react.useEffect)(function () {
    if (isPreconditionData || (block === null || block === void 0 ? void 0 : block.isPreconditionData)) {
      _GenericStore.dataStore.setValue(parentPath + '/isPreconditionData', true);
    }
  }, [isPreconditionData, block]);

  if (block && block.hasOwnProperty('type') && typeof ComponentList[block.type] !== 'undefined') {
    return /*#__PURE__*/_react["default"].createElement(ComponentList[block.type], {
      block: block,
      parentPath: parentPath + ((block === null || block === void 0 ? void 0 : block.path) ? block.path : ''),
      key: parentPath + (block === null || block === void 0 ? void 0 : block.path) ? block.path : '',
      number: number,
      onSubmit: onSubmit,
      isAutoSave: isAutoSave,
      isLogInArray: isLogInArray
    });
  } // component doesn't exist yet


  return /*#__PURE__*/_react["default"].createElement(function () {
    return /*#__PURE__*/_react["default"].createElement("div", null, "The component has not been created yet.");
  }, {
    key: '23213'
  });
}